import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Sheet: shadcn/ui's Sheet — a Dialog that slides from an edge — restyled as the kit's solid panel.
// The surface uses it for the panels the header menu opens (What I can see, Session record …) and
// for the shortcuts sheet. Like Dialog (the surface's own, ui/dialog.tsx), focus is trapped while
// open and returns to the opener, and nothing is written outside the container it opens in.
import { cva } from "class-variance-authority";
import { cn } from "./cn.js";
import { CloseButton, Dialog, DialogClose, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger, ModalContent, PLACEHOLDER_CLOSE_GLYPH, panelClasses, } from "./dialog.js";
export const Sheet = Dialog;
export const SheetTrigger = DialogTrigger;
export const SheetClose = DialogClose;
export const SheetHeader = DialogHeader;
export const SheetFooter = DialogFooter;
export const SheetTitle = DialogTitle;
export const SheetDescription = DialogDescription;
const sheetVariants = cva([panelClasses, "fixed"], {
    variants: {
        side: {
            right: "inset-y-0 right-0 h-full w-3/4 max-w-sm border-l",
            left: "inset-y-0 left-0 h-full w-3/4 max-w-sm border-r",
            top: "inset-x-0 top-0 border-b",
            bottom: "inset-x-0 bottom-0 rounded-t-16 border-t",
        },
        compact: { false: "gap-3 p-5", true: "gap-2 p-4" },
    },
    defaultVariants: { side: "right", compact: false },
});
export function SheetContent({ className, side, compact, closeGlyph = PLACEHOLDER_CLOSE_GLYPH, children, ...props }) {
    return (_jsxs(ModalContent, { "data-side": side ?? "right", "data-compact": compact ?? false, className: cn(sheetVariants({ side, compact }), className), ...props, children: [children, closeGlyph === null ? null : _jsx(CloseButton, { glyph: closeGlyph, compact: compact })] }));
}
//# sourceMappingURL=sheet.js.map